export default __webpack_public_path__ + "static/media/hobbiesCard.b43f64e7.png";